// angular
import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
// app
import { AppAnimations } from 'src/app/_shared/animations';
import { SkeletonLoaderService } from './../../../_core/services/skeleton-loader.service';
import { MetaService } from 'src/app/_core/services/meta.service';

@Component({
  animations: [ AppAnimations ],
  host: { '[@smoothAppearance]': '', 'class': 'app-dashboard' },
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styles: [`
    .page-wrapper {
      background-color: white;
    }
    .mark-as-unread {
      background-color: #fafafa !important
    }
  `
  ],
})

export class DashboardComponent {
  constructor(
    private _iconRegistry: MatIconRegistry,
    public _meta: MetaService,
    private _sanitizer: DomSanitizer,
    public _skeleton: SkeletonLoaderService,
  ) {
    this._iconRegistry.addSvgIcon('ico-help', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-help-faq.svg'));
  }
}
